<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import axios from "axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Insurance Companies",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Insurance Companies",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Insurance Companies",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "companyName",
          sortable: true,
          label: "NAME",
        },
        {
          key: "companyContact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "companyEmail",
          sortable: true,
          label: "EMAIL",
        },
        {
          key: "companyAddress",
          sortable: true,
          label: "ADDRESS",
        },
        {
          key: "patients",
          sortable: true,
          label: "CLIENTS",
        },
        {
          key: "yy",
          sortable: true,
          label: "PACKAGES",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingCompany: [],
      nameError: "",
      addressError: "",
      contactError: "",

      file: "",
      is_uploading: false,

      // Value from user input for adding Company
      data: {
        name: "",
        email: "",
        contact: "",
        address: "",
      },
      // edit Company
      editdata: {
        name: "",
        email: "",
        contact: "",
        address: "",
        id: "",
      },
      // delete Company
      deletedata: {
        name: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("insurance", ["InsuranceCompanies", "InsuranceStatus"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.InsuranceCompanies ? this.InsuranceCompanies.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.InsuranceCompanies ? this.InsuranceCompanies.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCompanies: "insurance/fetchInsuranceCompanies",
      AddCompany: "insurance/addInsuranceCompany",
      EditCompany: "insurance/editInsuranceCompany",
      DeleteCompany: "insurance/deleteInsuranceCompany",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingCompany = this.InsuranceCompanies.filter((Company) => {
          return Company.companyName.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingCompany.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingCompany = [];
      }
    },

    addCompany(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Company name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.existingCompany.length) {
        this.nameError = this.data.name + " exists already please";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.contact === "") {
        this.contactError = "Company Contact is required";
        return;
      } else {
        this.contactError = "";
      }
      if (this.data.address === "") {
        this.addressError = "Company Address is required";
        return;
      } else {
        this.addressError = "";
      }

      this.AddCompany(this.data);
    },

    resetAddCompany() {
      this.data.name = "";
      this.contactError = "";
      this.addressError = "";
      this.nameError = "";
      this.data.email = "";
      this.data.contact = "";
      this.data.address = "";
      this.modal_id = "";
    },
    resetEditCompany() {
      this.editdata.name = "";
      this.editdata.email = "";
      this.editdata.contact = "";
      this.editdata.address = "";
      this.editdata.id = "";
      this.contactError = "";
      this.addressError = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetDeleteCompany() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.contactError = "";
      this.addressError = "";
    },
    showEditModal(data) {
      this.editdata.name = data.item.companyName;
      this.editdata.address = data.item.companyAddress;
      this.editdata.email = data.item.companyEmail;
      this.editdata.contact = data.item.companyContact;
      this.editdata.id = data.item.id;
    },
    editCompany(modalId) {
      if (this.editdata.name === "") {
        this.nameError = "Company name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.contact === "") {
        this.contactError = "Company Contact is required";
        return;
      } else {
        this.contactError = "";
      }
      if (this.editdata.address === "") {
        this.addressError = "Company Address is required";
        return;
      } else {
        this.addressError = "";
      }
      this.modal_id = modalId;
      this.EditCompany(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.companyName;
      this.deletedata.id = data.item.id;
    },
    deleteCompany(modalId) {
      this.modal_id = modalId;
      this.DeleteCompany(this.deletedata);
    },
    PackRedirect(value) {
      this.$router.push(
        `/insurance/insurance_packages/${btoa(value.id)}/${btoa(value.companyName)}`
      );
    },

    //===== Upload services ================
    handleUpload() {
      this.file = this.$refs.file.files[0];
    },

    importFile(modelId) {
      this.is_uploading = true;
      let formData = new FormData();
      formData.append("file", this.file);

      const headers = { 'Content-Type': 'multipart/form-data' };
      axios.post('import_insurance_services', formData, { headers }).then((res) => {
        this.is_uploading = false;
        this.closeModal(modelId);
        if (res.status == 200) {
          let message = { 'msg': 'Success upload'}
          this.FetchCompanies();
          this.$store.dispatch('notification/success',message);
        } else {
          let message = { 'msg': 'Something went wrong and upload failed' }
          this.$store.dispatch('notification/error',message);
        }
      }).catch(()=>{
        this.is_uploading = false;
        this.closeModal(modelId);
        let message = { 'msg': 'Something went wrong and upload failed' }
        this.$store.dispatch('notification/error',message);
      });
    },
    resetUploadModal() {},

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchCompanies();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length"></div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <b-button v-if="user_permissions.add_insurance_company" variant="primary" v-b-modal.add-company-modal><i class="fa fa-plus"></i> Add New</b-button> |
                  <b-button v-b-modal.upload-modal variant="success"><i class="fa fa-upload"></i> Insurance prices</b-button>

                  <!-- modal starts -->
                  <b-modal id="add-company-modal" hide-footer @hidden="resetAddCompany">
                    <template #modal-title> Add New Insurance Company </template>
                    <div class="form-group mb-3">
                      <label>Company Name</label>
                      <div class="input-group">
                        <input
                            type="text"
                            placeholder="Enter Company Name"
                            class="form-control"
                            @keyup="checkName"
                            @input="resetError"
                            v-model="data.name"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>Contact</label>
                      <div class="input-group">
                        <input
                            type="number"
                            placeholder="Enter Phone Number"
                            class="form-control"
                            @input="resetError"
                            v-model="data.contact"
                        />
                      </div>
                      <div class="text-danger" v-if="contactError">
                        <em>{{ contactError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>Email</label>
                      <div class="input-group">
                        <input
                            type="email"
                            placeholder="Enter Email Address"
                            class="form-control"
                            @input="resetError"
                            v-model="data.email"
                        />
                      </div>
                      <!-- <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div> -->
                    </div>
                    <div class="form-group mb-3">
                      <label>Address</label>
                      <div class="input-group">
                        <input
                            type="text"
                            placeholder="Enter Company Address"
                            class="form-control"
                            @input="resetError"
                            v-model="data.address"
                        />
                      </div>
                      <div class="text-danger" v-if="addressError">
                        <em>{{ addressError }}</em>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="closeModal('add-company-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                          type="button"
                          class="btn btn-primary"
                          @click="addCompany('add-company-modal')"
                      >
                        <i class="fa fa-check"></i>
                        Submit
                        <b-spinner
                            v-if="InsuranceStatus"
                            variant="light"
                            small
                            label="Spinning"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->

                  <!--SERVICE EXCEL UPLOAD MODAL-->
                  <b-modal
                      id="upload-modal"
                      ref="modal"
                      hide-footer
                      title="Upload an excel file of service"
                      @hidden="resetUploadModal"
                  >
                    <div class="mb-2">
                      <label class="col-form-label" for="upload-file"
                      >Select file to upload:</label
                      >
                      <input
                          id="upload-file"
                          class="form-control"
                          type="file"
                          ref="file"
                          @change="handleUpload"
                      />
                    </div>
                    <div class="modal-footer">
                      <button
                          class="btn btn-secondary"
                          @click="$bvModal.hide('upload-modal')"
                          type="button"
                      >
                        Close
                      </button>
                      <button class="btn btn-primary" type="button" @click="importFile('upload-modal')">
                        Import Items
                        <b-spinner
                            v-if="is_uploading"
                            variant="light"
                            small
                            role="status"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>

                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        v-model="perPage"
                        :options="pageOptions"
                        class="form-select form-select-sm"
                        size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        class="form-control form-control-sm ms-2"
                        placeholder="Search..."
                        type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="InsuranceCompanies ? InsuranceCompanies : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                  <b-button v-if="user_permissions.edit_insurance_company"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-company-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button v-else
                  disabled
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-company-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button v-if="user_permissions.delete_insurance_company"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-company-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                  <b-button v-else
                  disabled
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-company-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
                <template #cell(yy)="data">
                  <b-button v-if="user_permissions.view_insurance_company_packages"
                    @click="PackRedirect(data.item)"
                    size="sm"
                    variant="success"
                    class="m-2"
                    ><i class="fa fa-eye"></i> View</b-button
                  >
                </template>
              </b-table>
              <center>
                <h3 v-if="!InsuranceCompanies" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- edit modal starts -->
            <b-modal id="edit-company-modal" hide-footer @hidden="resetEditCompany">
              <template #modal-title> Edit Company {{ editdata.new_name }}</template>
              <div class="form-group mb-3">
                <label>Company Name</label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Company Name"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="editdata.name"
                  />
                </div>
                <div class="text-danger" v-if="nameError">
                  <em>{{ nameError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Contact</label>
                <div class="input-group">
                  <input
                    type="number"
                    placeholder="Enter Phone Number"
                    class="form-control"
                    @input="resetError"
                    v-model="editdata.contact"
                  />
                </div>
                <div class="text-danger" v-if="contactError">
                  <em>{{ contactError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Email</label>
                <div class="input-group">
                  <input
                    type="email"
                    placeholder="Enter Email Address"
                    class="form-control"
                    @input="resetError"
                    v-model="editdata.email"
                  />
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Address</label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Company Address"
                    class="form-control"
                    @input="resetError"
                    v-model="editdata.address"
                  />
                </div>
                <div class="text-danger" v-if="addressError">
                  <em>{{ addressError }}</em>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-company-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editCompany('edit-company-modal')"
                >
                  <i class="fa fa-check"></i>
                  Save Changes
                  <b-spinner
                    v-if="InsuranceStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete company starts -->
            <b-modal id="delete-company-modal" hide-footer @hidden="resetDeleteCompany">
              <template #modal-title>
                <h4 class="text-danger">
                  Delete Company {{ deletedata.name }}
                </h4></template
              >
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this company? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-company-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteCompany('delete-company-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="InsuranceStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
